import { useEvaluatorPack } from '../addons'
import { AddOnFootnote, EvaluatorName } from './AddOn'

/**
 * Launch gate 9 — proposal §6, and IMPLEMENTATION.md decision 27.
 *
 * *"No surface in the product implies that it checks compliance."* So this is a
 * component rather than a sentence someone remembers to type, rendered by the
 * guideline surfaces themselves. A banner a page can forget is a banner a page
 * will forget.
 *
 * **It says where the limits go, and what the add-on pack adds — never what the
 * product lacks.** The first wording led with *these are the limits, not a check
 * against them*; a later one with *nothing here checks a portfolio*. Both were
 * true, and both described the base product by an absence. Decision 26 settled
 * what the honest sentence is: the base product's job ends at the export into the
 * customer's OMS, where pre-trade checks run, and verdicts inside GUARD are the
 * Snapshot Evaluator pack's. Naming those two satisfies the gate — nobody reads
 * this screen as a check — and it ends on what the reader can do.
 *
 * Worded for the installation it is on: the pack to add, or the pack already here.
 * Either way the pack's name is starred to its terms (decision 30). The component
 * name is the gate's, kept so every surface that renders it stays findable by
 * that name.
 */
export function NotEvaluated() {
  const pack = useEvaluatorPack()
  return (
    <p className="not-evaluated" role="note" data-testid="not-evaluated">
      <strong>These are the limits in force</strong> — the latest approved version
      of every rule, ready to export into your order management or compliance
      system for pre-trade checks
      {pack ? (
        <>
          {' '}— or evaluate them against your holdings with the <EvaluatorName />.
        </>
      ) : (
        <>
          . The <EvaluatorName /> add-on pack evaluates them against your holdings
          inside GUARD.
        </>
      )}
      <AddOnFootnote />
    </p>
  )
}
